import types from './types';
import {
    fetchElementsPaginated,
    deleteElement
} from './common';

const apiUrl = '/api/images';


export function fetchImages(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.LOAD_IMAGES);
}

export function deleteImage(id) {
    return deleteElement(apiUrl, id, types.DELETE_IMAGE);

}



// WEBPACK FOOTER //
// ./src/js/actions/image.js